import Tooltip from '@mui/material/Tooltip';

interface StatusLedProps {
  device?: string;
  status: string;
  size?: string | number;
}

const StatusLed = ({ device, status, size }: StatusLedProps) => {
  let classByStatus = '';
  let tooltipByStatus = null;

  switch (status) {
    case 'Online':
      classByStatus = 'is-online';
      tooltipByStatus =
        device === 'vehicle'
          ? 'En línea: este vehículo funciona correctamente'
          : 'En línea: este cargador funciona correctamente';
      break;
    case 'Offline':
      classByStatus = 'is-offline';
      tooltipByStatus =
        device === 'vehicle'
          ? 'Fuera de línea: este vehículo no tiene señal.'
          : 'Fuera de línea: este cargador no tiene señal.';
      break;
    case 'Waiting':
      classByStatus = 'is-waiting';
      tooltipByStatus =
        device === 'vehicle'
          ? 'Reconectando: este vehículo se esta reconectando debido a una pérdida de señal.'
          : 'Reconectando: este cargador se esta reconectando debido a una pérdida de señal.';
      break;
    case 'Out-of-Service':
      classByStatus = 'is-disabled';
      tooltipByStatus = 'Fuera de servicio: este vehículo no está operativo.';
      break;
    default:
      classByStatus = 'is-online';
      tooltipByStatus =
        device === 'vehicle'
          ? 'En línea: este vehículo funciona correctamente'
          : 'En línea: este cargador funciona correctamente';
      break;
  }

  return (
    <div className="status-led-container">
      <Tooltip title={tooltipByStatus}>
        <div className={`status-led ${classByStatus}`} style={{ height: size, width: size }} />
      </Tooltip>
    </div>
  );
};

export default StatusLed;
